import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { formatDate } from '../../lib/format';
import { Eyebrow } from '../primitives/Eyebrow';
import type { Article } from '../../content/schemas';

interface FeatureArticleProps {
  article: Article;
}

const Wrap = styled(Link)`
  display: block;
  padding: ${(p) => p.theme.step[6]}px;
  border: 1px solid ${(p) => p.theme.color.border.med};
  border-radius: 12px;
  background: ${(p) => p.theme.color.bg[1]};
  color: inherit;
  transition: border-color 160ms ${(p) => p.theme.ease};

  &:hover {
    border-color: ${(p) => p.theme.color.accent.amberLine};
  }
`;

const Headline = styled.h2`
  font-family: ${(p) => p.theme.font.serif};
  font-size: clamp(${(p) => p.theme.step[6]}px, 4vw, ${(p) => p.theme.step[9]}px);
  margin: 12px 0;
  letter-spacing: -0.02em;
  line-height: 1.1;
`;

const Lead = styled.p`
  margin: 0;
  font-size: ${(p) => p.theme.step[5]}px;
  color: ${(p) => p.theme.color.text[1]};
  line-height: 1.5;
`;

const Footer = styled.div`
  display: flex;
  gap: ${(p) => p.theme.step[5]}px;
  align-items: center;
  margin-top: ${(p) => p.theme.step[5]}px;
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
  font-family: ${(p) => p.theme.font.mono};
`;

export function FeatureArticle({ article }: FeatureArticleProps) {
  return (
    <Wrap to={`/research/${article.id}`}>
      <Eyebrow $variant="amber">FEATURED · {article.cat.toUpperCase()}</Eyebrow>
      <Headline>{article.title}</Headline>
      <Lead>{article.lead}</Lead>
      <Footer>
        <span>{article.author}</span>
        <span>·</span>
        <span>{formatDate(article.date)}</span>
        <span>·</span>
        <span>{article.read} MIN</span>
      </Footer>
    </Wrap>
  );
}
